<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar Unidad de Medida" aria-label="Agregar Unidad de Medida"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-table class="mb-0 crud-unit-measurement-table app-table"
                    responsive
                    sticky-header="60vh"
                    :stacked="isMobileViewport ? 'md' : false"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :tbody-tr-class="rowClass"
                    @row-clicked="onRowClicked"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template>

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(reference)="data">
                  <b>{{data.item.reference}}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(equivalence_fixed)="data">
                  <span v-b-tooltip.hover title="Equivalencias fijas">
                    <AppIcon name="lock" :font-scale="1.1" class="mr-1" :class="getEquivalenceFixed(data.item.equivalences) ? 'text-info' : 'text-muted'" />
                    <b-badge :variant="getEquivalenceFixed(data.item.equivalences) ? 'info' : 'secondary'" pill>{{getEquivalenceFixed(data.item.equivalences)}}</b-badge>
                    <span class="ml-1 text-muted small">{{getEquivalenceFixed(data.item.equivalences) == 1 ? 'fija' : 'fijas'}}</span>
                  </span>
                </template>

                <template v-slot:cell(equivalence_var)="data">
                  <span v-b-tooltip.hover title="Equivalencias variables">
                    <AppIcon name="refresh" :font-scale="1.1" class="mr-1" :class="getEquivalenceVar(data.item.equivalences) ? 'text-info' : 'text-muted'" />
                    <b-badge :variant="getEquivalenceVar(data.item.equivalences) ? 'info' : 'secondary'" pill>{{getEquivalenceVar(data.item.equivalences)}}</b-badge>
                    <span class="ml-1 text-muted small">{{getEquivalenceVar(data.item.equivalences) == 1 ? 'variable' : 'variables'}}</span>
                  </span>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-unit-measurement-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="openSub(data.item)">
                      <AppIcon name="visibility" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="straighten" title="No se encontraron unidades de medida" description="Agregá una unidad de medida para comenzar." />
          </b-card>
        </b-col>
      </b-row>

      <b-sidebar
          id="sidebar-unit-measurement-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle de la Unidad de Medida"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.reference">
                {{itemSelected.reference}}
              </span>
              <div>{{itemSelected.name}}</div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrev"
                        v-b-tooltip.hover
                        title="Unidad anterior"
                        @click="goPrev()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNext"
                        v-b-tooltip.hover
                        title="Unidad siguiente"
                        @click="goNext()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="straighten" /> Equivalencias
            </div>
            <b-table class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(formula)="row">
                <div v-html="getFormulaEquivalences(row.item)" :id="'popover-equivalence-' + row.item.id" style="cursor:pointer;"></div>

                <b-popover :target="'popover-equivalence-' + row.item.id" variant="info" triggers="hover">
                  <span v-if="parseFloat(row.item.surcharge)>0">RECARGO: {{ parseFloat(row.item.surcharge) }}%</span>
                  <span v-else><i>SIN RECARGO</i></span>
                </b-popover>
              </template>

              <template v-slot:cell(result)="row">
                {{row.item.unit_measurement_result.reference}}
              </template>

            </b-table>
            <EmptyState v-else icon="straighten" title="Sin equivalencias cargadas" description="Agregá equivalencias editando esta unidad de medida." />
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>

          <nav>
            <b-pagination class="mb-0"
                          size="sm"
                          pills
                          :total-rows="getRowCount(table.items)"
                          :per-page="table.perPage"
                          v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="lg"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="straighten" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="3">
            <b-form-group label="Referencia">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.reference"
                            required
                            placeholder="Ingresar una referencia">
              </b-form-input>
            </b-form-group>
          </b-col>                 
          <b-col md="9">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>         
        </b-row>

        <b-row v-if="crud.form.equivalence.unit_measurement_entry">
          <b-col md="12">
            <hr>
          </b-col>

          <b-col md="12">
            <b-row :key="keyForceUpdate">
              <b-col md="2" >
                <b-form-group label="Entrada">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.equivalence.unit_measurement_entry.name"
                                :readonly="true">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <FindObject type="unitMeasurement" 
                            tag="Salida"
                            @select-object="loadUnitMeasurementResult($event)" 
                            :valueID="crud.form.equivalence.unit_measurement_result_id"
                            render="search"/>                
              </b-col>              
              <b-col md="3">
                <b-form-group label="Operación">                  
                  <b-form-select v-model="crud.form.equivalence.operation" :options="arr.select.operation" size="sm"></b-form-select>                    
                </b-form-group>                                
              </b-col>              
              <b-col md="2" v-if="crud.form.equivalence.operation=='division_fijo' || crud.form.equivalence.operation=='multiplicacion_fijo'">
                <b-form-group label="Valor">
                  <b-form-input type="number"
                                size="sm"
                                v-model="crud.form.equivalence.value"
                                placeholder="Ingrese un valor numérico">
                  </b-form-input>              
                </b-form-group>                
              </b-col>
              <b-col md="2" v-if="crud.form.equivalence.operation=='division_variable' || crud.form.equivalence.operation=='multiplicacion_variable'">
                <b-form-group label="Variable">
                  <b-form-select v-model="crud.form.equivalence.variable" :options="arr.select.typeVariable" size="sm"></b-form-select>                    
                </b-form-group>                
              </b-col>              

              <b-col md="1" class="d-flex align-items-end mb-3">
                <b-button variant="success" @click="addEquivalence()" size="sm" title="Agregar Equivalencia">
                  <AppIcon name="add" />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              
              <b-col>              
                <b-row>
                  <b-col md="12">                                                  
                    <b-table  class="mb-0 crud-unit-measurement-table-equivalence app-table app-table--compact"
                              responsive
                              :stacked="isMobileViewport ? 'md' : false"
                              :hover="true"
                              :small="true"
                              :fixed="false"
                              :items="tableEquivalenece.items"
                              :fields="tableEquivalenece.fields"
                              v-if="tableEquivalenece.items.length">
                      
                      <template v-slot:table-colgroup="scope">
                        <col
                          v-for="field in scope.fields"                    
                          :key="field.key"
                          :style="{ width: field.width }"
                        >
                      </template>                         
                      
                      <template v-slot:cell(formula)="row">   
                        <div v-html="getFormulaEquivalences(row.item)"></div>  
                      </template>                      

                      <template v-slot:cell(result)="row">                        
                        {{row.item.unit_measurement_result.reference}}
                      </template>

                      <template v-slot:cell(surcharge)="row">                        
                        <span v-if="parseFloat(row.item.surcharge)>0">{{ parseFloat(row.item.surcharge) }}%</span>                        
                        <span v-else><i>SIN RECARGO</i></span>
                      </template>                      

                      <template v-slot:cell(f_action)="data">
                        <b-dropdown right
                                    no-caret
                                    size="sm"
                                    variant="link"
                                    boundary="window"
                                    :toggle-class="isMobileViewport ? 'crud-unit-measurement-action-toggle-labeled' : 'app-table-action-toggle'">
                          <template v-slot:button-content>
                            <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                            <span v-if="isMobileViewport">Opciones</span>
                          </template>
                          <b-dropdown-item
                            @click="openSurcharge(data.item)"
                            title="Aplica un recargo al cálculo del precio"
                            v-if="data.item.id">
                            <AppIcon name="percent" class="mr-1" /> Recargo
                          </b-dropdown-item>
                          <b-dropdown-item @click="removeEquivalence(data.index)">
                            <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                          </b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </b-table>
                    <EmptyState v-else icon="straighten" title="Sin equivalencias" description="Agregá una equivalencia para continuar." />
                  </b-col>                    
                </b-row> 
              </b-col>              

            </b-row>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>

      <!-- CRUD SURCHARGE -->
      <b-modal v-model="modal.surcharge.active"
              size="lg">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="percent" /></span>
          <h5 class="app-modal-header__title">{{this.modal.surcharge.title}}</h5>
        </div>

        <b-row>
          <b-col md="2">
            <b-form-group label="ID">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.surcharge.id"
                            :disabled="true">
              </b-form-input>
            </b-form-group>
          </b-col>                 
          <b-col md="7">
            <b-form-group label="Referencia">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.surcharge.reference"
                            :disabled="true">
              </b-form-input>
            </b-form-group>
          </b-col>    
          <b-col md="3">
            <b-form-group label="Recargo">
              <b-input-group size="sm" append="%">
                <b-form-input type="number"
                                size="sm"
                                v-model="crud.surcharge.surcharge"
                                required>
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>                   
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.surcharge.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveSurcharge()">Guardar</b-button>          
        </div>
      </b-modal>      
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.PRODUCTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudUnitMeasurement',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },
        isMobileViewport: false,
        detailDrawer: false,
        tableSub : {
          items: [],
          fields: []
        },       
        tableEquivalenece : {
          items: [],
          fields: []
        },                 
        crud: {
          form: {
            id: 0,
            reference: '',
            name: '',            
            equivalence: {
              operation: 'division_fijo',
              variable: 'cantidad',
              value: 0,
              unit_measurement_entry: null,
              unit_measurement_entry_id: 0,              
              unit_measurement_result: null,
              unit_measurement_result_id: 0,
              detail: [],
            }
          }, 
          surcharge: {
            id: 0,
            reference: '',
            surcharge: 0,
          }       
        },
        modal: {
          form: {
            active: false,
            title: ''
          },  
          surcharge: {
            active: false,
            title: ''
          }        
        },    
        arr: {
          units: [],
          select: {
            operation: [
              { value: 'division_fijo', text: 'DIVISION  (FIJO)' },
              { value: 'division_variable', text: 'DIVISION (VARIABLE)' },
              { value: 'multiplicacion_fijo', text: 'MULTIPLICACION (FIJO)' },
              { value: 'multiplicacion_variable', text: 'MULTIPLICACION (VARIABLE)' },
            ],
            typeVariable: [              
              { value: 'cantidad', text: 'CANTIDAD' },
              { value: 'densidad', text: 'DENSIDAD' },
            ]            
          }
        },
        itemSelected: null,    
        keyForceUpdate: 0,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.loadFieldTable()
      this.load()

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    computed: {
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrev() {
        return this.currentIndex > 0
      },
      canGoNext() {
        if(this.currentIndex < 0) {
          return false
        }
        return this.currentIndex < (this.table.items.length - 1)
      },
    },
    watch: {
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Resalta la fila cuyo registro está abierto en el drawer.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el kebab de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      loadFieldTable () {
        // TABLE UNIDADES DE MEDIDAS
        this.table.fields = []
        this.tableSub.fields = []
        this.tableEquivalenece.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass(''), width:"5%"})
        this.table.fields.push({key: 'reference', label: 'Referencia', class: 'align-middle ' + this.alignClass(''), width:"15%"})
        this.table.fields.push({key: 'name', label: 'Nombre', class: 'align-middle ' + this.alignClass(''), width:"30%"})
        this.table.fields.push({key: 'equivalence_fixed', label: 'Equivalencia Fijas', class: 'align-middle ' + this.alignClass(''), width:"20%"})
        this.table.fields.push({key: 'equivalence_var', label: 'Equivalencia Variable', class: 'align-middle ' + this.alignClass(''), width:"20%"})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acciones' : '', class: 'align-middle ' + this.alignClass('text-right'), width:"10%"})

        // TABLE DETALLE
        this.tableSub.fields.push({key: 'formula', label: 'Formula', class:"align-middle", width:"70%"})
        this.tableSub.fields.push({key: 'result', label: 'Resultado', class:"align-middle", width:"30%"})

        // TABLE EQUIVALENCIAS
        this.tableEquivalenece.fields.push({key: 'formula', label: 'Formula', class:"align-middle", width:"45%"})
        this.tableEquivalenece.fields.push({key: 'result', label: 'Resultado', class:"align-middle", width:"25%"})
        this.tableEquivalenece.fields.push({key: 'surcharge', label: 'Recargo', class:"align-middle", width:"20%"})
        this.tableEquivalenece.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle", width:"10%"})
      },
      getRowCount (items) {
        return items.length
      },

      // CRUD
      load(forceEquivalence=false) {
        this.table.isBusy = true
        var result = serviceAPI.obtenerUnidadesMedidas()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arr.units = data
          this.table.isBusy = false

          this.table.items.forEach(element => {
            if(forceEquivalence) {
              if(element.id == this.itemSelected.id) {
                this.edit(element)
              }
            }
          })

        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.reference = '' 
        this.crud.form.name = '' 

        this.crud.form.equivalence.operation = 'division_fijo'
        this.crud.form.equivalence.variable = 'cantidad'
        this.crud.form.equivalence.value = 0
        this.crud.form.equivalence.unit_measurement_entry = null
        this.crud.form.equivalence.unit_measurement_entry_id = 0              
        this.crud.form.equivalence.unit_measurement_result = null
        this.crud.form.equivalence.unit_measurement_result_id = 0
        this.crud.form.equivalence.detail = []
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Unidad de Medida"
        this.modal.form.active = true
      },
      edit(item) {
        this.openSub(item)

        this.crud.form.id = item.id
        this.crud.form.reference = item.reference
        this.crud.form.name = item.name                 

        this.crud.form.equivalence.operation = 'division_fijo'
        this.crud.form.equivalence.variable = 'cantidad'
        this.crud.form.equivalence.value = 0
        this.crud.form.equivalence.unit_measurement_entry = item,
        this.crud.form.equivalence.unit_measurement_entry_id =  item.id,              
        this.crud.form.equivalence.unit_measurement_result = null
        this.crud.form.equivalence.unit_measurement_result_id = 0
        this.crud.form.equivalence.detail = []

        this.loadEquivalences(item)

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Unidad de Medida"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Unidad de Medida',
          okTitle: 'SI',
          cancelTitle: 'NO',
          danger: true,
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarUnidadMedida(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarUnidadMedida(this.crud.form);
        } else {
          var result = serviceAPI.agregarUnidadMedida(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      
      // EQUIVALENCIA
      loadUnitMeasurementResult(object) {
        if(object){
          this.crud.form.equivalence.unit_measurement_result = object
          this.crud.form.equivalence.unit_measurement_result_id = object.id
        } else {
          this.crud.form.equivalence.unit_measurement_result = null
          this.crud.form.equivalence.unit_measurement_result_id = 0
        }
      },
      loadEquivalences(item) {
        if(item.equivalences) {
          item.equivalences.forEach(element => {            
            var variable = ''
            var value = 0

            if(element.operation == 'division_variable' ||
               element.operation == 'multiplicacion_variable') {             
              variable = element.variable
              value = 0
            } 

            if(element.operation == 'division_fijo' ||
               element.operation == 'multiplicacion_fijo') {                     
              variable = ''
              value = element.value        
            }         

            this.crud.form.equivalence.detail.push({
              id: element.id,
              unit_measurement_entry: this.crud.form.equivalence.unit_measurement_entry,
              unit_measurement_entry_id: this.crud.form.equivalence.unit_measurement_entry_id,
              operation: element.operation,
              variable: variable,
              value: value,
              unit_measurement_result: element.unit_measurement_result,
              unit_measurement_result_id: element.unit_measurement_result_id,     
              surcharge: element.surcharge,              
            })
          });
        }       
        
        this.tableEquivalenece.items = this.crud.form.equivalence.detail 
        this.clearEquivalence()
      },
      addEquivalence() {

        // NO SE PUEDE GUARDAR MAS DE UNA VEZ LA MISMA EQUIVALENCIA
        var existe = false
        if(this.crud.form.equivalence.detail.length) {
          this.crud.form.equivalence.detail.forEach(element => {
            if(element.unit_measurement_result_id == this.crud.form.equivalence.unit_measurement_result_id) {              
              existe = true
            }
          });
        }
        if(existe) {
          this.$awn.alert("La equivalencia ya se encuentra agregada");
          return false
        }        

        // NO SE PUEDE GUARDAR UNA EQUIVALENCIA CON LAS MISMAS UNIDADES DE MEDIDAS
        if(this.crud.form.equivalence.unit_measurement_entry_id == this.crud.form.equivalence.unit_measurement_result_id) {              
          this.$awn.alert("La entrada y salida deben ser diferentes");
          return false          
        }        

        // LA UNIDAD DE MEDIDA DE RESULTADO DEBE ESTAR CARGADA
        if(!this.crud.form.equivalence.unit_measurement_result_id) {              
          this.$awn.alert("La unidad de medida de resultado debe estar cargada");
          return false          
        }                

        // AGREGO REGISTRO
        var variable = ''
        var value = 0

        if(this.crud.form.equivalence.operation == 'division_variable' ||
           this.crud.form.equivalence.operation == 'multiplicacion_variable') {             
          variable = this.crud.form.equivalence.variable
          value = 0

          // VALIDO QUE LA VARIABLE ESTE CARGAGA
          if(!variable) {
            this.$awn.alert("No se cargo la variable para la formula");
            return false                      
          }          
        } 

        if(this.crud.form.equivalence.operation == 'division_fijo' ||
           this.crud.form.equivalence.operation == 'multiplicacion_fijo') {                 
          variable = ''
          value = this.crud.form.equivalence.value        

          // VALIDO QUE EL VALOR ESTE CARGAGO
          if(!value) {
            this.$awn.alert("No se cargo el valor para la formula");
            return false                      
          }
        }

        this.crud.form.equivalence.detail.push({
            id: 0,
            unit_measurement_entry: this.crud.form.equivalence.unit_measurement_entry,
            unit_measurement_entry_id: this.crud.form.equivalence.unit_measurement_entry_id,
            operation: this.crud.form.equivalence.operation,
            variable: variable,
            value: value,
            unit_measurement_result: this.crud.form.equivalence.unit_measurement_result,
            unit_measurement_result_id: this.crud.form.equivalence.unit_measurement_result_id,          
        })

        this.tableEquivalenece.items = this.crud.form.equivalence.detail 
        this.clearEquivalence()
      },
      removeEquivalence(index) {
        this.crud.form.equivalence.detail.splice(index, 1)
      },
      clearEquivalence() {
        this.crud.form.equivalence.operation = 'division_fijo'
        this.crud.form.equivalence.variable = 'cantidad'
        this.crud.form.equivalence.value = 0        
        this.crud.form.equivalence.unit_measurement_result = null
        this.crud.form.equivalence.unit_measurement_result_id = 0
        this.forceUpdate()  
      },
      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },
      getEquivalenceFixed(item) {
        var cant = 0
        if(item) {          
          item.forEach(element => {
            if(element.operation == 'division_fijo' || element.operation == 'multiplicacion_fijo') {
              cant = cant + 1
            }
          });
        }        
        return cant
      },
      getEquivalenceVar(item) {
        var cant = 0
        if(item) {
          item.forEach(element => {
            if(element.operation == 'division_variable' || element.operation == 'multiplicacion_variable') {
              cant = cant + 1
            }
          });
        }
        return cant
      },  
      getFormulaEquivalences(item) {        
        let unit_measurement = null
        if(item.unit_measurement_input != undefined) {
          unit_measurement = item.unit_measurement_input
        }
        if(item.unit_measurement_entry != undefined) {
          unit_measurement = item.unit_measurement_entry
        }

        let reference = ''
        if(item.operation=='division_fijo') {
          reference = unit_measurement.reference + ' / ' + parseFloat(item.value).toFixed(4) + ' = ' + item.unit_measurement_result.reference
        }
        if(item.operation=='multiplicacion_fijo') {
          reference = unit_measurement.reference + ' x ' + parseFloat(item.value).toFixed(4) + ' = ' + item.unit_measurement_result.reference
        }
        if(item.operation=='division_variable') {
          reference = unit_measurement.reference + ' / ' + item.variable.toUpperCase() + ' = ' + item.unit_measurement_result.reference
        }
        if(item.operation=='multiplicacion_variable') {
          reference = unit_measurement.reference + ' x ' + item.variable.toUpperCase() + ' = ' + item.unit_measurement_result.reference
        }  
        return reference
      },
      
      // RECARGO
      openSurcharge(item) {        
        this.crud.surcharge.id = item.id
        this.crud.surcharge.reference = this.getFormulaEquivalences(item)
        this.crud.surcharge.surcharge = item.surcharge

        this.modal.surcharge.title = "Agregar Recargo"
        this.modal.surcharge.active = true
      },
      saveSurcharge() {                
        if (!this.crud.surcharge.id) {
          this.$awn.alert("No se encuentra la equivalencia");
          return false;
        } 

        let loader = this.$loading.show();

        var result = serviceAPI.aplicarRecargo(this.crud.surcharge);
        result.then((response) => {
          this.modal.surcharge.active = false
          loader.hide()          
          this.$awn.success("Datos guardados con éxito");

          this.load(true)
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      // COMPROBANTE DETAIL
      openSub(item) {
        this.itemSelected = item
        this.tableSub.items = item.equivalences
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSub.items = []
        this.itemSelected = null
        this.detailDrawer = false
      },
      goPrev() {
        if(this.canGoPrev) this.openSub(this.table.items[this.currentIndex - 1])
      },
      goNext() {
        if(this.canGoNext) this.openSub(this.table.items[this.currentIndex + 1])
      },
    }
  }
</script>
<style>
  .btn.crud-unit-measurement-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-unit-measurement-action-toggle-labeled:hover,
  .btn.crud-unit-measurement-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-unit-measurement-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    /* En esta vista se pidió alinear también la columna de acciones a la
       izquierda en mobile, a diferencia del resto de los listados (donde
       queda a la derecha por diseño compartido en _list-views.scss). */
    .crud-unit-measurement-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
    /* Misma excepción que la tabla principal, aplicada acá a la tabla de
       equivalencias del modal: título "Acción" visible y alineado a la
       izquierda junto al kebab, en vez del comportamiento por defecto
       (sin título, alineado a la derecha) de _list-views.scss. */
    .crud-unit-measurement-table-equivalence.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-unit-measurement-table-equivalence.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
